<div
  class="banner-with-text"
  [ngStyle]="{ 'background-image': 'url(' + backgroundPic + ')' }"
>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 class="hdg">{{ sectionTitle }}</h1>
        <h5 class="sb-hdg">Auctions</h5>
      </div>
    </div>
  </div>
</div>

<div class="blog-wrap">
  <div class="container">
    <div class="row mt-4 pt-1 mb-3">
      <div class="col-auto">
        <h3 class="page-h3 m-0">{{ sectionTitle }}</h3>
      </div>
      <div class="col-auto ml-auto">
        <button
          class="lgv-btn mr-3"
          [ngClass]="{ active: !showListView }"
          role="button"
          (click)="showListView = false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <g fill="none" fill-rule="evenodd">
              <g fill="currentColor" fill-rule="nonzero">
                <path
                  d="M1210.335 346.889c.98 0 1.776.795 1.776 1.776v3.559c0 .98-.795 1.776-1.776 1.776h-3.559c-.98 0-1.776-.795-1.776-1.776v-3.559c0-.98.795-1.776 1.776-1.776h3.559zm8.889 0c.98 0 1.776.795 1.776 1.776v3.559c0 .98-.795 1.776-1.776 1.776h-3.559c-.98 0-1.776-.795-1.776-1.776v-3.559c0-.98.795-1.776 1.776-1.776h3.559zm-8.89 1.778h-3.556v3.555h3.555v-3.555zm8.888 0h-3.555v3.555h3.555v-3.555zM1210.335 338c.98 0 1.776.795 1.776 1.776v3.559c0 .98-.795 1.776-1.776 1.776h-3.559c-.98 0-1.776-.795-1.776-1.776v-3.559c0-.98.795-1.776 1.776-1.776h3.559zm8.889 0c.98 0 1.776.795 1.776 1.776v3.559c0 .98-.795 1.776-1.776 1.776h-3.559c-.98 0-1.776-.795-1.776-1.776v-3.559c0-.98.795-1.776 1.776-1.776h3.559zm-8.89 1.778h-3.556v3.555h3.555v-3.555zm8.888 0h-3.555v3.555h3.555v-3.555z"
                  transform="translate(-1205 -338) matrix(-1 0 0 1 2426 0)"
                />
              </g>
            </g>
          </svg>
        </button>
        <button
          class="lgv-btn"
          [ngClass]="{ active: showListView }"
          role="button"
          (click)="showListView = true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="13"
            viewBox="0 0 16 13"
          >
            <g fill="none" fill-rule="evenodd">
              <g fill="currentColor" fill-rule="nonzero">
                <path
                  d="M1266.071 350.143c.513 0 .929.416.929.928 0 .513-.416.929-.929.929h-14.142c-.513 0-.929-.416-.929-.929 0-.512.416-.928.929-.928h14.142zm0-5.572c.513 0 .929.416.929.929 0 .513-.416.929-.929.929h-14.142c-.513 0-.929-.416-.929-.929 0-.513.416-.929.929-.929h14.142zm0-5.571c.513 0 .929.416.929.929 0 .512-.416.928-.929.928h-14.142c-.513 0-.929-.416-.929-.928 0-.513.416-.929.929-.929h14.142z"
                  transform="translate(-1251 -339) matrix(-1 0 0 1 2518 0)"
                />
              </g>
            </g>
          </svg>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="auction-search">
          <div
            class="form-group mb-4 no-float-fields no-float-with-search search-width"
          >
            <mat-form-field appearance="outline">
              <input
                matInput
                type="text"
                [(ngModel)]="searchTerm"
                [formControl]="searchControl"
                placeholder="Search"
                maxlength="50"
              />
            </mat-form-field>
            <span
              class="search-icon"
              role="button"
              (click)="resetSearch()"
              *ngIf="searchControl.value != null; else showSearch"
            >
              <img
                src="../assets/images/cross.svg"
                title="filter-search-icon"
                alt="filter-clear-icon"
              />
            </span>
            <ng-template #showSearch>
              <span class="search-icon">
                <img src="/assets/images/search-icon2.svg" />
              </span>
            </ng-template>
          </div>

          <div class="form-group mb-4 no-float-fields auc-width">
            <mat-select
              [(value)]="category.value"
              (selectionChange)="categoryFilter($event.value)"
              placeholder="Auction Category"
            >
              <mat-option [value]="null">All</mat-option>
              <mat-option
                *ngFor="let category of categories"
                [value]="category.value"
                >{{ category.text }}
              </mat-option>
            </mat-select>
          </div>

          <div class="form-group mb-4 no-float-fields sort-width">
            <mat-select
              (selectionChange)="sortFilter($event.value)"
              placeholder="Sort By"
              [(value)]="sortModel.value"
            >
              <mat-option [value]="null">All</mat-option>
              <mat-option
                *ngFor="let sort of sortingObject"
                [value]="sort.value"
                >{{ sort.text }}
              </mat-option>
            </mat-select>
          </div>

          <div
            class="form-group mb-4 no-float-fields sort-width"
            *ngIf="isShowStatusFilter"
          >
            <mat-select
              (selectionChange)="statusFilter($event.value)"
              placeholder="Status"
            >
              <mat-option [value]="statusValue.LiveUpcomingPast" selected
                >All</mat-option
              >
              <mat-option [value]="statusValue.liveUpcoming"
                >Available</mat-option
              >
              <mat-option [value]="statusValue.past">Sold</mat-option>
            </mat-select>
          </div>

          <ng-container
            *ngIf="currentAuctionType === auctionType.currentAuction.title"
          >
            <div class="form-group mb-4 no-float-fields sort-width">
              <mat-select
                [(value)]="saleType"
                (selectionChange)="saletypeFilter($event.value)"
                placeholder="Sale Type"
              >
                <mat-option [value]="0">All</mat-option>
                <mat-option
                  *ngFor="let saletype of saletypesForDD"
                  [value]="saletype.value"
                  >{{ saletype.text }}
                </mat-option>
              </mat-select>
            </div>
          </ng-container>

          <ng-container
            *ngIf="currentAuctionType == auctionType.pastAuction.title"
          >
            <div class="form-group mb-4">
              <a
                *ngIf="auctionStatus == auctionStatuses.past"
                role="button"
                role="button"
                (click)="switchToArchive()"
                class="btn btn-white-border btnWithMarg btn-full viewAchivedAuction-link"
              >
                View Archived Auctions
              </a>
            </div>

            <a
              *ngIf="auctionStatus == auctionStatuses.archived"
              role="button"
              role="button"
              (click)="switchToRecent()"
              class="btn btn-white-border btnWithMarg btn-full viewAchivedAuction-link"
            >
              View Recent Auctions
            </a>
          </ng-container>
        </div>
      </div>
    </div>

    <div
      class="empty-state-container empty-pad-2"
      *ngIf="this.totalAuction == 0; else showTable"
    >
      <div class="empty-state-content">
        <img
          alt="empty-state"
          src="../../../../assets/images/empty-state-icon.svg"
        />
        <h3 class="_heading">No Auction Found</h3>
      </div>
    </div>

    <ng-template #showTable>
      <ng-container *ngIf="currentAuctionType != auctionType.turnKeySale.title">
        <div class="row gutter-16 auctionPagesCard" id="auctionPagesCard">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <app-paginator
                  [paginationId]="'server'"
                  [currentPage]="pageNumber"
                  [pageSize]="pageSize"
                  (page)="onPageChange($event)"
                  *ngIf="totalAuction > pageSize"
                ></app-paginator>
              </div>
            </div>
          </div>
          <div
            class="col-12 auctions-outer-mobile-list"
            [ngClass]="{ 'col-md-6 col-lg-4': !showListView }"
            *ngFor="
              let item of auctionData
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: pageSize,
                      currentPage: pageNumber,
                      totalItems: totalAuction
                    }
            "
          >
            <auction-card
              [auctionData]="item"
              [listView]="showListView"
              [routeType]="null"
            ></auction-card>
          </div>

          <div class="container">
            <div class="row">
              <div class="col-12">
                <app-paginator
                  [paginationId]="'server'"
                  [currentPage]="pageNumber"
                  [pageSize]="pageSize"
                  (page)="onPageChange($event)"
                  *ngIf="totalAuction > pageSize"
                ></app-paginator>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="currentAuctionType == auctionType.turnKeySale.title">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <app-paginator
                [paginationId]="'server1'"
                [currentPage]="pageNumber"
                [pageSize]="pageSize"
                (page)="onPageChange($event)"
                *ngIf="totalAuction > pageSize"
              ></app-paginator>
            </div>
          </div>
        </div>
        <div class="turnKeyCards">
          <div class="turnHdg">
            <h1>PAST TURN KEY SALES</h1>
          </div>
          <div class="turnCardsInner">
            <div
              class="eachTurnCards"
              *ngFor="
                let auction of auctionData
                  | paginate
                    : {
                        id: 'server1',
                        itemsPerPage: pageSize,
                        currentPage: pageNumber,
                        totalItems: totalAuction
                      }
              "
            >
              <div class="row">
                <div class="col-lg-6 leftWrap mb-3 mb-lg-0">
                  <img
                    alt="Cover Photo"
                    AuctionDefaultImage
                    *ngIf="auction"
                    [image]="auction.coverPhoto"
                  />
                </div>
                <div class="col-lg-6 rightWrap">
                  <div class="inner">
                    <div class="forLogo">
                      <img
                        class="logo"
                        alt="Client Logo"
                        AuctionDefaultImage
                        *ngIf="auction"
                        [image]="auction.clientLogo"
                      />
                    </div>
                    <div class="badge-type forBadge">
                      <span class="card-badge-colored">{{
                        auction.saleTypePublicName
                      }}</span>
                    </div>
                    <h1 class="name">{{ auction.title }}</h1>
                    <p class="des" [innerHTML]="auction.tagline"></p>
                    <p
                      class="location"
                      *ngIf="
                        auction.saleType.isDetailPageInHouse &&
                        auction.locations
                      "
                    >
                      {{ auction.locations }}
                    </p>
                    <p
                      class="dateTime"
                      [innerHtml]="
                        auction?.saleType?.auctionDate
                          | auctionDateFormat
                            : auction?.auctionStatus
                            : auction?.timeZoneName
                            : auction?.startDateTime
                            : auction?.endDateTime
                            : auction?.saleType?.dateText
                      "
                    ></p>
                    <div class="forDeatils">
                      <button
                        type="button"
                        class="btn btn-colored"
                        [routerLink]="['/', auction.auctionCode]"
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <app-paginator
                    [paginationId]="'server1'"
                    [currentPage]="pageNumber"
                    [pageSize]="pageSize"
                    (page)="onPageChange($event)"
                    *ngIf="totalAuction > pageSize"
                  ></app-paginator>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>

    <!-- turn Sale kay page start here -->
    <div class="empty-state-container empty-pad-2 d-none">
      <div class="empty-state-content">
        <img
          alt="empty-state"
          src="../../../../assets/images/empty-state-icon.svg"
        />
        <h3 class="_heading">
          There are no current active listings. <br />
          Check back for future Turn Key Sales.
        </h3>
      </div>
    </div>
    <!-- turn Sale kay page end here -->
  </div>
</div>
